import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FactorType, AuthTransaction, LoginClient } from './login.models';
import { LOGIN_FEATURE_KEY, LoginState } from './login.reducer';

export const getLoginState =
  createFeatureSelector<LoginState>(LOGIN_FEATURE_KEY);

export const transaction = createSelector(
  getLoginState,
  (state) => state?.transaction,
);

export const getFactorByType = createSelector(
  transaction,
  (t: AuthTransaction | undefined, props: { factorType: FactorType }) =>
    t?.factors?.find((factor) => factor.factorType === props.factorType),
);

export const signInError = createSelector(
  getLoginState,
  (state) => state.signInError,
);

export const isTransactionInProgress = createSelector(
  getLoginState,
  (state) => state?.isTransactionInProgress,
);

export const newPhoneNumber = createSelector(
  getLoginState,
  (state) => state.newPhoneNumber,
);

export const registrationPhoneNumber = createSelector(
  getLoginState,
  (state) => state.registrationPhoneNumber,
);

export const canGoBack = createSelector(
  getLoginState,
  (state) => !!state.canGoBack,
);

export const hasTransaction = createSelector(
  getLoginState,
  (state) => state?.hasTransaction,
);

export const hasBeenSignedIn = createSelector(
  getLoginState,
  (state) => state.hasBeenSignedIn,
);

export const isANewUser = createSelector(
  getLoginState,
  (state) => state.isANewUser,
);

export const shouldSkipMfaWelcomeScreen = createSelector(
  getLoginState,
  (state) => state.shouldSkipMfaWelcomeScreen,
);

export const hasValidCredentials = createSelector(
  getLoginState,
  (state) => state.hasValidCredentials,
);

export const isAfterRegistration = createSelector(
  getLoginState,
  (state) => state.isAfterRegistration,
);

export const getEapToken = createSelector(
  getLoginState,
  (state) => state.eapToken,
);

export const getLoginClientId = createSelector(
  getLoginState,
  (state) => state.clientId,
);

export const stepupToken = createSelector(
  getLoginState,
  (state) => state.stepupToken,
);

export const userAgreementVersion = createSelector(
  getLoginState,
  (state) => state.userAgreementVersion,
);

export const isSpinnerShown = createSelector(
  getLoginState,
  (state) => state.isSpinnerShown,
);

export const isProfileLoading = createSelector(
  getLoginState,
  (state) => state.isProfileLoading,
);

export const spinnerCount = createSelector(
  getLoginState,
  (state) => state.spinnerCount,
);

export const getTokenText = createSelector(
  getLoginState,
  (state) => state.tokenText,
);

export const getStructIdLevel3 = createSelector(
  getLoginState,
  (state) => state.structIdLevel3,
);

export const resetPasswordError = createSelector(
  getLoginState,
  (state) => state.resetPasswordError,
);

export const getLockOutLoginRedirectUrl = createSelector(
  getLoginState,
  (state) => state.lockOutLoginRedirectUrl,
);
